import { Edit, KeyboardArrowDown } from '@mui/icons-material';
import {
    Box,
    IconButton,
    InputBase,
    MenuItem,
    Select,
    Tooltip,
    useTheme,
} from '@mui/material';
import { useMemo } from 'react';

const columnShape = [
    {
        Header: 'Name',
        accessor: 'fullName',
    },
    {
        Header: 'Profession',
        accessor: 'profession.name',
    },
    {
        Header: 'Phone',
        accessor: 'phoneNumber',
    },
    {
        Header: 'Email',
        accessor: 'email',
    },
    {
        Header: 'Password',
        accessor: 'plainPassword',
    },
    {
        Header: 'Role',
        accessor: 'role',
    },
    {
        Header: 'Action',
        accessor: 'id',
        Cell: ({ row, handleEdit }) => {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Tooltip title="Edit">
                        <IconButton
                            onClick={() => handleEdit(row.original)}
                            sx={{ color: 'text.disabled', fontSize: 18 }}
                        >
                            <Edit />
                        </IconButton>
                    </Tooltip>
                </Box>
            );
        },
    },
];
export function SelectColumnFilter({ column }) {
    const { filterValue, setFilter, preFilteredRows, id } = column;
    const theme = useTheme();
    const options = useMemo(() => {
        const options = new Set();
        preFilteredRows.forEach((row) => options.add(row.values[id]));
        return [...options.values()];
    }, [id, preFilteredRows]); // Render a multi-select box

    return (
        <Select
            value={filterValue || ''}
            onChange={(e) => setFilter(e.target.value || undefined)}
            IconComponent={() => <KeyboardArrowDown color="disabled" />}
            input={
                <InputBase
                    sx={{
                        height: 40,
                        width: 110,
                        fontSize: 12,
                        fontWeight: 600,
                        padding: '0 8px',
                        borderRadius: '8px',
                        color: 'text.primary',
                        backgroundColor:
                            theme.palette.mode === 'light'
                                ? '#ECEFF5'
                                : 'divider',
                        '& .MuiPopover-paper': {
                            boxShadow: 'none',
                        },
                        '& > .MuiSelect-select': {
                            paddingRight: '0 !important',
                        },
                    }}
                />
            }
        >
            <MenuItem
                value=""
                sx={{
                    fontSize: 12,
                    fontWeight: 500,
                }}
            >
                All
            </MenuItem>
            {options.map((option, i) => (
                <MenuItem
                    key={i}
                    value={option}
                    sx={{
                        fontSize: 12,
                        fontWeight: 500,
                    }}
                >
                    {option}
                </MenuItem>
            ))}
        </Select>
    );
}
export default columnShape;
